import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


@Component({
    selector: 'ecp-array-sort',
    templateUrl: './array-sort.component.html',
    styleUrls: ['./array-sort.component.css']
})
export class ArraySortComponent implements OnInit {
    @Input() list: Array<string>;
    @Output() event = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }


    /* æµç¨ä¸ç§»ãä¸ç§»ãå é¤*/

    public arr = this.list;

    //   public arr = this.mockjsService.getSupperTableList();
    swapItems(arr, index1, index2) {
        const self = this;
        arr[index1] = arr.splice(index2, 1, arr[index1])[0];

        for (let i = 0; i < arr.length; i++) {
            arr[i].no = i + 1;
        }

        self.list = arr;

    };

    upData(arr, index) {
        const self = this;
        if (arr.length > 1 && index !== 0) {
            self.swapItems(arr, index, index - 1);
        } else {
            //self.message.create('warning', `å·²ç»å°é¡¶äºï¼`);
        }
        self.event.emit(self.list);

    };

    downData(arr, index) {
        console.log('ä¸ç§»');
        const self = this;
        if (arr.length > 1 && index < (arr.length - 1)) {
            self.swapItems(arr, index, index + 1);
        } else {
            //self.message.create('warning', `å·²ç»å°åºäºï¼`);
        }
        self.event.emit(self.list);
    };

    delData(arr, index) {
        const self = this;
        let delitem;
        delitem = arr.splice(index, 1);
        for (let i = 0; i < arr.length; i++) {
            arr[i].no = i + 1;
        }
        self.list = arr;
        self.event.emit(self.list);
    }

}
